import { Common, ApiBind } from './common.model';

export class DeviceModelGroupDeviceModel extends Common {
  @ApiBind({ column: 'device_model_id' })
  id: number;
}
